import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import { useForm, Controller } from "react-hook-form";
import ApiAmusementService from "../../../core/api/api.amusementService";
import TextEditor from "../_Components/CkEditor/Index";
import { PatternFormat } from "react-number-format";
import SelectComponent from "../_Components/ReactSelectComponent";

const CreateOrEditAmusementReserveItemGroup = ({
  showModalReserveItemGroup,
  setShowModalReserveItemGroup,
  selectedReserveItemGroupId,
}) => {
  const [services, setServices] = useState([]);
  const [formInputs, setFormInputs] = useState({ place: null, service: null });

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      defaultReserveCountPerDay: 10,
      reservationExpirationTime: "23:59",
      isDisplay: true,
      isActive: true,
    },
  });

  // Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (data) {
          setServices(data);
        }
      } catch (error) {
      }
    };

    fetchServices();
  }, []);
  // Fetch item details in edit mode
  useEffect(() => {
    const fetchReserveItem = async () => {
      if (selectedReserveItemGroupId !== 0 && services.length > 0) {
        try {
          const response = await ApiAmusementServiceReserveItemGroup.get(selectedReserveItemGroupId);
          setValue("id", response.data.id);
          setValue("title", response.data.title);
          setValue("isActive", response.data.isActive);
          // setValue("isDisplay", response.data.isDisplay);
          // setValue("isFullCapacity", response.data.isFullCapacity);
          setValue("defaultReserveCountPerDay", response.data.defaultReserveCountPerDay);
          setValue("tooltip", response.data.tooltip);
          setValue("viewOrder", response.data.viewOrder);
          setValue("reservationExpirationTime", response.data.reservationExpirationTime);

          if (response.data.amusementServiceId) {
            const initialService = services.find((service) => service.id === response.data.amusementServiceId);
            if (initialService) {
              const selectedOption = {
                value: initialService.id,
                label: initialService.name,
                type: "service",
              };
              setFormInputs({ service: selectedOption });
              setValue("amusementServiceId", initialService.id);
            }
          }
        } catch (error) {
        }
      } else {
        reset({
          id: 0,
          defaultReserveCountPerDay: 10,
          reservationExpirationTime: "23:59",
        });
      }
    };

    fetchReserveItem();
  }, [selectedReserveItemGroupId, services, setValue, reset]);

  // Handle input changes
  const inputChangeHandler2 = (selectedOption) => {
    if (selectedOption?.type === "service") {
      setFormInputs({
        ...formInputs,
        service: selectedOption,
      });
    }
    else
      setFormInputs("")
  };

  const handleClose = () => {
    setShowModalReserveItemGroup(false);
  };

  const onSubmit = async (data) => {
    try {
      let response = null;
      if (data.id <= 0) {
        response = await ApiAmusementServiceReserveItemGroup.create(data);
      } else {
        response = await ApiAmusementServiceReserveItemGroup.update(data.id, data);
      }
      if (response.succeeded) {
        document.getElementById("submitButton").click();
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        setShowModalReserveItemGroup(false);
      }
    } catch (error) {
    }
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  const handleChangeIsNumber = (event, onChange) => {
    const value = event.target.value;
    // فقط مقادیر عددی بزرگتر از 0 مجاز باشند
    if (/^[0-9]\d*$|^$/.test(value)) {
      onChange(value); // مقدار ورودی را به‌روزرسانی می‌کنیم
    }
  };
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered show={showModalReserveItemGroup} onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {selectedReserveItemGroupId !== 0 && services.length > 0
                  ? "ویرایش گروه آیتم رزرو"
                  : "ایجاد گروه آیتم رزرو جدید"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Row>
                  <Col xs="12" style={{ zIndex: "3" }}>
                    <Controller
                      name="amusementServiceId"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <SelectComponent
                          className="w-20 mt-2"
                          placeholder="انتخاب تفریح"
                          options={services?.map((item) => ({
                            value: item.id,
                            label: item.name,
                            type: "service",
                          }))}
                          value={formInputs.service || ""}
                          onChange={(selectedOption) => {
                            inputChangeHandler2(selectedOption);
                            onChange(selectedOption?.value);
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="title"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="عنوان"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                    {errors.title && <span>لطفا عنوان را وارد نمایید</span>}
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="defaultReserveCountPerDay"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="ظرفیت روزانه"
                          type="text"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={field.value || ""}
                          onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12" className="mt-3 mb-2 text-muted-1 font-size-sm">
                    توضیحات قابل نمایش در tooltip
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="tooltip"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextEditor
                          data={value || ""}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            onChange(data);
                            setValue("tooltip", data);
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12">
                    <FormControlLabel
                      control={
                        <Controller
                          control={control}
                          name={"isActive"}
                          render={({ field: { onChange, value, ref } }) => (
                            <Checkbox color="primary" onChange={onChange} checked={value || false} inputRef={ref} />
                          )}
                        />
                      }
                      label="فعال"
                    />
                  </Col>
                  {/* <Col xs='12'>
                    <FormControlLabel
                      control={
                        <Controller
                          control={control}
                          name={"isDisplay"}
                          render={({ field: { onChange, value, ref } }) => (
                            <Checkbox
                              color="primary"
                              onChange={onChange}
                              checked={value || false}
                              inputRef={ref}
                            />
                          )}
                        />
                      }
                      label="IsDisplay"
                    />
                  </Col> */}
                  {/* <Col xs='12'>
                    <FormControlLabel
                      control={
                        <Controller
                          control={control}
                          name={"isFullCapacity"}
                          render={({ field: { onChange, value, ref } }) => (
                            <Checkbox
                              color="primary"
                              onChange={onChange}
                              checked={value || false}
                              inputRef={ref}
                            />
                          )}
                        />
                      }
                      label="ظرفیت تکمیل"
                    />
                  </Col> */}
                  <Col xs="12">
                    <Controller
                      name="reservationExpirationTime"
                      control={control}
                      rules={{ required: false }}
                      render={({ field: { onChange, value } }) => (
                        <PatternFormat
                          customInput={TextField}
                          label="ساعت اتمام فروش"
                          size="small"
                          type="search"
                          onKeyDown={(e) => {
                            if (e.key === "Escape") {
                              e.stopPropagation()
                            }
                          }}
                          margin="normal"
                          value={value || ""}
                          variant="outlined"
                          onChange={onChange}
                          placeholder="00:00"
                          format="##:##"
                          allowEmptyFormatting={false}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12">
                    <Controller
                      name="viewOrder"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="ترتیب نمایش"
                          type="text"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={field.value || ""}
                          onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default CreateOrEditAmusementReserveItemGroup;
